import { Common, Company } from '@stockbit/ui';
import debounce from 'lodash.debounce';
import { useCallback } from 'react';
import { ChartTimeFrames, FRChartTimeFrames } from '../constants.types';

const { Flex, Text } = Common;
const { RadioButton } = Company;

type TimeFrameType = ChartTimeFrames | FRChartTimeFrames;

interface TimeframeButtonsProps {
  showTimeframes: boolean;
  timeframe: string;
  onSelectTimeframe: (v: TimeFrameType) => void;
  className?: string;
  timeFrameList: { value: TimeFrameType; label: string }[];
}

function TimeframeButtons({
  showTimeframes,
  timeframe,
  onSelectTimeframe,
  className,
  timeFrameList = [],
}: TimeframeButtonsProps) {
  const debouncedOnChange = useCallback(
    debounce((e: React.ChangeEvent<HTMLInputElement>) => {
      onSelectTimeframe(e.target.value as ChartTimeFrames);
    }, 0),
    [onSelectTimeframe],
  );

  return showTimeframes ? (
    <Flex className={className}>
      <RadioButton.Group
        value={timeframe}
        onChange={debouncedOnChange}
        type="solid-primary"
      >
        {timeFrameList.map((opt) => (
          <RadioButton.Button key={opt.value} value={opt.value}>
            <Text
              className="text"
              height="1.15"
              padding="2px 0"
              align="center"
              width="30px"
            >
              {opt.label}
            </Text>
          </RadioButton.Button>
        ))}
      </RadioButton.Group>
    </Flex>
  ) : null;
}

export default TimeframeButtons;
